"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var fabric_1 = require("fabric");
var nanoid_1 = require("nanoid");
var constants_1 = require("../common/constants");
var object_exporter_1 = __importDefault(require("../utils/object-exporter"));
var object_importer_1 = __importDefault(require("../utils/object-importer"));
var get_selection_type_1 = __importDefault(require("../utils/get-selection-type"));
var Base_1 = __importDefault(require("./Base"));
var parser_1 = __importDefault(require("../parser"));
var parser_2 = require("../utils/parser");
var Scene = /** @class */ (function (_super) {
    __extends(Scene, _super);
    function Scene() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = "";
        _this.name = "";
        _this._importVersion = 0;
        _this.exportAsComponent = function () { return __awaiter(_this, void 0, void 0, function () {
            var activeObject, selectionType, frame, objectExporter, isMixed, clonedObjects, objects, _loop_1, _a, _b, object, e_1_1, group, component, metadata, component, metadata;
            var e_1, _c;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        activeObject = this.canvas.getActiveObject();
                        selectionType = (0, get_selection_type_1.default)(activeObject);
                        frame = this.editor.frame.options;
                        objectExporter = new object_exporter_1.default();
                        if (!(activeObject && selectionType)) return [3 /*break*/, 10];
                        isMixed = selectionType.length > 1;
                        if (!(activeObject.type === "activeSelection" || activeObject.type === "group")) return [3 /*break*/, 9];
                        clonedObjects = [];
                        objects = activeObject._objects;
                        _loop_1 = function (object) {
                            var cloned;
                            return __generator(this, function (_e) {
                                switch (_e.label) {
                                    case 0: return [4 /*yield*/, new Promise(function (resolve) {
                                            object.clone(function (c) {
                                                c.clipPath = undefined;
                                                resolve(c);
                                            }, _this.editor.config.propertiesToInclude);
                                        })];
                                    case 1:
                                        cloned = _e.sent();
                                        clonedObjects = clonedObjects.concat(cloned);
                                        return [2 /*return*/];
                                }
                            });
                        };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 8]);
                        _a = __values(objects), _b = _a.next();
                        _d.label = 2;
                    case 2:
                        if (!!_b.done) return [3 /*break*/, 5];
                        object = _b.value;
                        return [5 /*yield**/, _loop_1(object)];
                    case 3:
                        _d.sent();
                        _d.label = 4;
                    case 4:
                        _b = _a.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _d.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        group = new fabric_1.fabric.Group(clonedObjects);
                        component = objectExporter.export(group.toJSON(this.editor.config.propertiesToInclude), frame);
                        metadata = component.metadata ? component.metadata : {};
                        return [2 /*return*/, __assign(__assign({}, component), { top: 0, left: 0, metadata: __assign(__assign({}, metadata), { category: isMixed ? "mixed" : "single", types: selectionType }) })];
                    case 9:
                        component = objectExporter.export(activeObject.toJSON(this.editor.config.propertiesToInclude), frame);
                        metadata = component.metadata ? component.metadata : {};
                        return [2 /*return*/, __assign(__assign({}, component), { top: 0, left: 0, metadata: __assign(__assign({}, metadata), { category: isMixed ? "mixed" : "single", types: selectionType }) })];
                    case 10: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Export Canvas objects to be loaded as resources by PIXI loader
         * @returns
         */
        _this.exportLayers = function (template) { return __awaiter(_this, void 0, void 0, function () {
            var elements, _a, _b, _c, index, layer, preview, objectURL, e_2_1;
            var e_2, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        elements = [];
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 7, 8, 9]);
                        _a = __values(template.layers.entries()), _b = _a.next();
                        _e.label = 2;
                    case 2:
                        if (!!_b.done) return [3 /*break*/, 6];
                        _c = __read(_b.value, 2), index = _c[0], layer = _c[1];
                        if (!(layer.type === "StaticVideo")) return [3 /*break*/, 3];
                        elements = elements.concat({
                            id: layer.id,
                            type: "StaticVideo",
                            // @ts-ignore
                            url: layer.src,
                            duration: 5000,
                            display: {
                                from: 0,
                                to: 5000,
                            },
                            cut: {
                                from: 0,
                                to: 0,
                            },
                            position: {
                                x: layer.left,
                                y: layer.top,
                                zIndex: index,
                                width: layer.width,
                                height: layer.height,
                                scaleX: layer.scaleX,
                                scaleY: layer.scaleY,
                            },
                            objectId: layer.id,
                        });
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.editor.renderer.renderLayer(layer, {})];
                    case 4:
                        preview = _e.sent();
                        objectURL = (0, parser_2.base64ImageToFile)(preview);
                        elements = elements.concat({
                            id: layer.id,
                            type: "StaticImage",
                            url: objectURL,
                            duration: 5000,
                            display: {
                                from: 0,
                                to: 5000,
                            },
                            cut: {
                                from: 0,
                                to: 0,
                            },
                            position: {
                                x: layer.left,
                                y: layer.top,
                                zIndex: index,
                                width: layer.width,
                                height: layer.height,
                                scaleX: layer.scaleX,
                                scaleY: layer.scaleY,
                            },
                            objectId: layer.id,
                        });
                        _e.label = 5;
                    case 5:
                        _b = _a.next();
                        return [3 /*break*/, 2];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_2_1 = _e.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/, elements];
                }
            });
        }); };
        /**
         * Deserializes JSON data
         * @returns Json Template
         */
        _this.importFromJSON = function (template) { return __awaiter(_this, void 0, void 0, function () {
            var version, frameParams, frame, objectImporter, updatedTemplateLayers, _a, _b, layer, element, e_3_1, safeZoneAdjusted, finalScene;
            var e_3, _c;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        version = ++this._importVersion;
                        this.name = template.name;
                        this.id = template.id;
                        frameParams = template.frame;
                        this.editor.objects.clear();
                        this.editor.frame.resize({
                            width: frameParams.width,
                            height: frameParams.height,
                        });
                        frame = this.editor.frame.frame;
                        objectImporter = new object_importer_1.default(this.editor);
                        updatedTemplateLayers = template.layers.map(function (layer) {
                            if (layer.type === constants_1.LayerType.BACKGROUND) {
                                return __assign(__assign({}, layer), { shadow: _this.config.shadow });
                            }
                            return layer;
                        });
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 8]);
                        _a = __values(updatedTemplateLayers), _b = _a.next();
                        _d.label = 2;
                    case 2:
                        if (!!_b.done) return [3 /*break*/, 5];
                        layer = _b.value;
                        if (version !== this._importVersion)
                            return [2 /*return*/]; // a newer import superseded this one
                        return [4 /*yield*/, objectImporter.import(layer, frame)];
                    case 3:
                        element = _d.sent();
                        if (version !== this._importVersion)
                            return [2 /*return*/];
                        if (element) {
                            if (this.config.clipToFrame) {
                                element.clipPath = frame;
                            }
                            this.canvas.add(element);
                        }
                        else {
                            console.log("UNABLE TO LOAD OBJECT: ", layer);
                        }
                        _d.label = 4;
                    case 4:
                        _b = _a.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_3_1 = _d.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        if (version !== this._importVersion)
                            return [2 /*return*/];
                        safeZoneAdjusted = this.editor.safeZone.fitSceneToSafeZone();
                        finalScene = safeZoneAdjusted ? this.exportToJSON() : template;
                        this.editor.zoom.zoomToFit();
                        this.editor.objects.updateContextObjects();
                        this.editor.history.save();
                        return [2 /*return*/, {
                                scene: finalScene,
                                safeZoneAdjusted: safeZoneAdjusted,
                            }];
                }
            });
        }); };
        return _this;
    }
    Scene.prototype.exportToJSON = function () {
        var animated = false;
        var canvasJSON = this.canvas.toJSON(this.config.propertiesToInclude);
        var frame = this.editor.frame.options;
        var template = {
            id: this.id ? this.id : (0, nanoid_1.nanoid)(),
            name: this.name ? this.name : "Untitled design",
            layers: [],
            frame: {
                width: frame.width,
                height: frame.height,
            },
            metadata: {
                animated: animated,
            },
        };
        var layers = canvasJSON.objects.filter(function (object) { return object.type !== constants_1.LayerType.FRAME; });
        var objectExporter = new object_exporter_1.default();
        layers.forEach(function (layer) {
            var exportedObject = objectExporter.export(layer, frame);
            template.layers = template.layers.concat(exportedObject);
        });
        template.metadata = __assign(__assign({}, template.metadata), { animated: animated });
        return template;
    };
    Scene.prototype.importFromSVG = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var design;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, parser_1.default)(url)
                        // @ts-ignore
                    ];
                    case 1:
                        design = _a.sent();
                        // @ts-ignore
                        this.importFromJSON(design);
                        return [2 /*return*/];
                }
            });
        });
    };
    return Scene;
}(Base_1.default));
exports.default = Scene;
//# sourceMappingURL=Scene.js.map